<div class="list-item-skeleton">
  <nz-skeleton
    [nzActive]="active"
    [nzAvatar]="showAvatar"
    [nzParagraph]="{ rows: rows }"
    [nzTitle]="{ width: titleWidth }"
  ></nz-skeleton>
</div>
